<template>
    <h1 class="scroll-m-20 text-foreground text-3xl font-extrabold tracking-tight lg:text-5xl leading-[48px ">
        <slot/>
    </h1>
</template>